'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'sun-bright';
var width = 576;
var height = 512;
var aliases = ["sun-alt"];
var unicode = 'e28f';
var svgPathData = ['M192 256a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z', 'M304 544l-32 0 0-112 32 0 0 112zM174.9 391.8l-79.2 79.2-22.6-22.6 79.2-79.2 22.6 22.6zM503 448.3l-22.6 22.6-79.2-79.2 22.6-22.6 79.2 79.2zM288 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256zm0-224a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM112 272l-112 0 0-32 112 0 0 32zm464 0l-112 0 0-32 112 0 0 32zM174.9 120.2L152.2 142.9 73 63.7 95.7 41 174.9 120.2zM503 63.7l-79.2 79.2-22.6-22.6 79.2-79.2 22.6 22.6zM304 80l-32 0 0-112 32 0 0 112z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSunBright = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;